
import React, { PropTypes } from 'react';

import _ from 'lodash';
import shortId from 'shortid';

import SimpleFileInput from '../../../../../common/components/c_SourceSimpleFileInput';
import ProgressComponentList from '../../../../../common/components/C_ProgressComponentList';
import FlatButton from '../../../../../common/components/c_FlatButton';
import DocumentItem from './DocumentItem';

// styling obj
const addButtonStyle = {
  display: 'inline-block',
  top: '11px',
  width: '165px',
  transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1), border-color 450ms cubic-bezier(0.23, 1, 0.32, 1)'
};

// text constants
const formHeading = 'Documents';

const formText = 'Please attach your resume, if you have one, any licenses, designations and reference letters.';

export default class Documents extends ProgressComponentList {

  static propTypes = {
    documents: PropTypes.object,
    profileId: PropTypes.number.isRequired,
    model: PropTypes.string.isRequired,
    staticData: PropTypes.object.isRequired,
    tempState: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired,
    errorUpdate: PropTypes.func.isRequired
  }

  onUploadStart = (err, infoObj) => {
    const clientId = `${this.getIncrementedChar()}${shortId.generate()}`;
    this.updateTempState(this.props.model, clientId, null, {
      clientId,
      isNew: true,
      fileName: infoObj.name,
      fileSize: infoObj.size,
      storagePath: infoObj.nameWithFolder
    });
  }

  onS3Load = err => {
    // updating UI optimistically so we only need to know if there was an error
    if(err && process.env.NODE_ENV !== 'production') {
      console.error(err);
    }
  }

  handleRemove = (clientId) =>
    () => this.removeListItem(clientId);


    // Override ValidatedForm.validateForm()
  validateForm() {
    return _.filter(this.refs, ref => ref.validateForm)
      .reduce((valid, section) => section.validateForm() && valid, true);
  }

  render() {
    const documentsArr = this.getList(false, ['employmentEnd', 'employmentStart'], ['desc', 'desc']);

    return (
      <div className='documents-container application-section-container clearfix'>
        <div className='form-heading'>
          {formHeading}
        </div>
        <div className='form-text'>
          {this.props.submitted ? '': formText}
        </div>
        <SimpleFileInput
          className='file-uploader'
          noMessage
          pristineClass=''
          loadingClass=''
          successClass=''
          failureClass=''
          accept={['pdf', 'doc', 'docx', 'tiff', 'txt', 'JPG', 'JPEG', 'jpg', 'jpeg', 'png']}
          remoteFolder='applicants'
          onLoadStart={this.onUploadStart}
          onS3Load={this.onS3Load}
          signingRoute='/api/s3/put-sign'
          maxSize={process.env.AWS_FILE_UPLOAD_SIZE}
        >
          <FlatButton
            style={{...addButtonStyle, ...(!documentsArr.length && {top: '10.5px'} || {})}}
            label='Attach File'
          />
        </SimpleFileInput>

        {

          documentsArr.map((document, index) =>
            <DocumentItem
              key={index}
              ref={document.clientId}
              document={document}
              validation={this.props.validation}
              staticData={this.props.staticData}
              updateTempState={this.updateTempState}
              tempState={this.props.tempState}
              onChange={this.onChange.bind(this)}
              onRemove={this.handleRemove(document.clientId)}
              />)
        }

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/c_Documents/index.js